import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Post, apiURL } from '../../../utils/apiCalls';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material'; // Import MUI CircularProgress

const loadScript = (src) => new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = () => {
    console.log('razorpay loaded successfully');
    resolve(true);
  };
  script.onerror = () => {
    console.log('error in loading razorpay');
    resolve(false);
  };
  document.body.appendChild(script);
});

const RenderRazorpay = ({
  orderId,
  keyId,
  keySecret,
  currency,
  amount,
  email,
  phone,
  page,
  handleCallBack,
}) => {
  const navigate = useNavigate();
  const paymentId = useRef(null);
  const paymentMethod = useRef(null);
  const [loading, setLoading] = useState(false);  // State to manage the loader

  const displayRazorpay = async (options) => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
      return;
    }

    const rzp1 = new window.Razorpay(options);

    rzp1.on('payment.submit', (response) => {
      paymentMethod.current = response.method;
    });

    rzp1.on('payment.failed', (response) => {
      paymentId.current = response.error.metadata.payment_id;
    });

    rzp1.open();
  };

  const handlePayment = async (status, orderDetails = {}) => {
    setLoading(true);  // Set loading to true when payment is being processed
    console.log(page, "pagepage")
    let payload = status === 'success' ? { status: 'SUCCESS', ...orderDetails } : { status: 'CANCELLED', razorpay_order_id: orderId };
    let url = page === 'subcription' ? '/api/v1/payments/sub_payment_capture' :
      page === 'project' ? '/api/v1/payments/payment_capture' : 
      page === 'layout_payment' ? '/api/v1/payments/procurement/payment_capture' : 
      page === 'ad_payment' ? '/api/v1/ads/payments/capture' : 
      '/api/v1/payments/cust_project_payment_capture';
    const response = await Post(apiURL + url, payload);
    console.log(response, "response")

    if (response.data.status) {
      if (response.data.payment_status === 'SUCCESS') {
        console.log("dddpagepage")
        if (page === 'subcription') {
          sessionStorage.setItem('subscription', true);
          if (handleCallBack) await handleCallBack('SUCCESS');
          navigate(`/dashboard/subscribe`);  // Redirect to subscription page if `sub` is true
        }
        else if (page === 'layout_payment' && handleCallBack) {
          // Call callback for layout_payment before navigation
          await handleCallBack('SUCCESS');
          navigate(`/dashboard/paymentsucess/${orderId}`, {
            state: { page: 'layout_payment' }
          });
        }
        else if (page === 'ad_payment' && handleCallBack) {
          console.log("ad_payment ad_payment")
          // Call callback for ad_payment - it will handle navigation after ad creation
          await handleCallBack('SUCCESS');
          // Don't navigate here - let the callback handle navigation after ad creation
        }
        else {
          navigate(`/dashboard/paymentsucess/${orderId}`, {
            state: { page: page === 'project' ? 'project' : 'custom_project' }  // Sending params as state
          });  // Otherwise, navigate to payment success page
        }
      }
    }
    setLoading(false);  // Set loading to false after processing
  };

  const options = {
    key: keyId,
    amount: amount,
    currency: currency,
    order_id: orderId,
    handler: function (response) {
      console.log(response);
      handlePayment('success', response);
    },
    modal: {
      confirm_close: true,
      ondismiss: async (reason) => {
        const {
          reason: paymentReason, field, step, code,
        } = reason && reason.error ? reason.error : {};
        // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly. 
        if (reason === undefined) {
          console.log('cancelled');
          handlePayment('Cancelled');
        }
        // Reason 2 - When modal is auto closed because of time out
        else if (reason === 'timeout') {
          console.log('timedout');
          handlePayment('timedout');
        }
        // Reason 3 - When payment gets failed.
        else {
          console.log('failed');
          handlePayment('failed', {
            paymentReason, field, step, code,
          });
        }
      },
    },

    retry: {
      enabled: false,
    },
    timeout: 900,
    theme: {
      color: '',
    },
    prefill: {
      email: email,
      contact: phone,
    },
    theme: {
      color: '#F37254',
    },
  };

  useEffect(() => {
    console.log('Loading Razorpay...');

    if (orderId && amount) {
      displayRazorpay(options);
    }
  }, [orderId]);

  return (
    <div>
      {loading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',  // Make sure the loader is centered
          }}
        >
          <CircularProgress />
          <p>Processing your payment...</p>
        </Box>
      )}
    </div>
  );
};

RenderRazorpay.propTypes = {
  orderId: PropTypes.string.isRequired,
  keyId: PropTypes.string.isRequired,
  keySecret: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
};

export default RenderRazorpay;
